var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"numCorrect":_vm.numCorrect,"numTotal":_vm.numTotal}}),_c('div',{staticClass:"my_container"},[(_vm.questions.length)?_c('QuestionBox',{attrs:{"currentQuestion":_vm.questions[_vm.index],"next":_vm.next,"increment":_vm.increment}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }